import $ from 'jquery';
$(document).ready(() => {
    $(window).on('load resize orientationchange', function() {
        $('.slider-staff .carousel').each(function(){
            let $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() >= 768) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 2.25,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        autoplay: true,
                        infinite: true,
                        dots: false,
                        prevArrow: false,
                        nextArrow: false
                    });
                }
            }
        });
    });
})

